if (!customElements.get('email-marketing-packages')) {
  customElements.define(
    'email-marketing-packages',
    class EmailMarketingPackages extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-package-dialog]');
        this.confirmButton = this.dialog.querySelector('[data-package-confirm]');
        this.buttons = Array.from(this.querySelectorAll('[data-package-select]'));
        this.pendingButton = null;

        this.buttons.forEach((button) => button.addEventListener('click', () => this.onSelect(button)));

        // Clicking anywhere in a package column (e.g. the heading) selects that package too.
        this.querySelectorAll('thead [data-package-column]').forEach((cell) =>
          cell.addEventListener('click', () => {
            const button = this.getButton(cell.dataset.packageColumn);
            if (button && !button.disabled) this.onSelect(button);
          })
        );

        this.confirmButton.addEventListener('click', () => this.onConfirm());
        this.dialog.querySelectorAll('[data-package-cancel]').forEach((button) =>
          button.addEventListener('click', () => this.dialog.close())
        );
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        // Fires for cancel, Escape and backdrop clicks alike.
        this.dialog.addEventListener('close', () => this.markSelected(null));
      }

      getButton(key) {
        return this.buttons.find((button) => button.dataset.packageSelect === key);
      }

      onSelect(button) {
        this.pendingButton = button;
        this.markSelected(button.dataset.packageSelect);

        const message = this.dialog.querySelector('[data-package-message]');
        message.textContent = message.dataset.template.replace('[package]', button.dataset.packageName);
        this.dialog.querySelector('[data-package-price]').textContent = button.dataset.packagePrice;

        this.dialog.showModal();
      }

      markSelected(key) {
        this.querySelectorAll('[data-package-column]').forEach((cell) =>
          cell.classList.toggle('is-selected', cell.dataset.packageColumn === key)
        );
        this.buttons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.packageSelect === key));
      }

      // A cart permalink goes straight to checkout with only this package, skipping the cart page.
      onConfirm() {
        if (!this.pendingButton) return;

        window.location.assign(`${window.routes.cart_url}/${this.pendingButton.dataset.variantId}:1`);
      }
    }
  );
}
